export default __webpack_public_path__ + "static/shahidh-muhammed-2f149025d93c6f001492ba438b80dcbc.png";